import React from 'react';
import { Link } from 'react-router-dom';
import { TreeNavigation } from 'react-unity';
import moment from 'moment';
import SubscriptionRequest from '../../../models/entities/SubscriptionRequest';

interface SubscriptionsHomeActionsRowProps {
	subscription: SubscriptionRequest;
	seePermissionsReport: (sub: SubscriptionRequest) => void;
	handleAttestModal: (sub: SubscriptionRequest) => void;
}

const SubscriptionsHomeActiosnRow = ({ subscription, seePermissionsReport, handleAttestModal }: SubscriptionsHomeActionsRowProps) => {

	const needsAttestation = () => {
		if (!subscription.lastAttestationDate) return true;

		const twelveMonthsAgo = moment().subtract(12, 'months');
		const lastAttestation = moment(subscription.lastAttestationDate);

		return lastAttestation.isBefore(twelveMonthsAgo);
	};

	return (
		<TreeNavigation>
			{subscription.cansSeePermissionsReport() && (
				<TreeNavigation.Item label="Permissions Report" onClick={() => seePermissionsReport(subscription)} />
			)}
			{subscription?.canSeeAttestRequest() && needsAttestation() && (
				<TreeNavigation.Item
					label="Attest"
					onClick={() => handleAttestModal(subscription)}
				/>
			)}
			{subscription?.canSeePortOpeningRequests() && (
				<TreeNavigation.Dropdown label="Port Opening Requests" className="submenu">
					{subscription.canSubmitPortOpeningRequests() && (
						<Link to={`/subscriptions/${subscription?.id}/portOpeningRequest/new`}>
							<TreeNavigation.Item label="Create a Request" />
						</Link>
					)}
					<Link to={`/subscriptions/${subscription?.id}/PortOpeningRequestsHistory`}>
						<TreeNavigation.Item label="Request History" />
					</Link>
					
				</TreeNavigation.Dropdown>
			)}
			{subscription?.canSeeDNDRequests() && ( //TODO: change to canSeeDoNotDecryptRequest
				<TreeNavigation.Dropdown label="DPI (Deep Packet Inspection) / SSL Exception Requests" className="submenu">
					{subscription.canSubmitPortOpeningRequests() && (
						<Link to={`/subscriptions/${subscription?.id}/doNotDecryptRequests/new`}>
							<TreeNavigation.Item label="Create a Request" />
						</Link>
					)}
					<Link to={`/subscriptions/${subscription?.id}/doNotDecryptRequestsHistory`}>
						<TreeNavigation.Item label="Request History" />
					</Link>
				</TreeNavigation.Dropdown>
			)}
			<Link to={`/nsg/${subscription?.createdSubscriptionId}`}>
				<TreeNavigation.Item label="Network Security Group" />
			</Link>
			{/*subscription?.canSeePolicyExemptionRequests() && (
				<TreeNavigation.Dropdown label="Policy Exception Requests" className="submenu">
					<Link to={`/subscriptions/${subscription?.id}/PolicyExemptionRequests/new`}>
						<TreeNavigation.Item label="Create a Request" />
					</Link>
					<Link to={`/subscriptions/${subscription?.id}/PolicyExemptionRequests`}>
						<TreeNavigation.Item label="Request History" />
					</Link>
				</TreeNavigation.Dropdown>
			)*/}
			{subscription?.canSeeSubscriptionAdminConsent() && (
				<Link to={`/subscriptions/${subscription?.id}/adminConsent`}>
					<TreeNavigation.Item label="Graph API Admin Consent" />
				</Link>
			)}
			{subscription?.isConnected && (
				<TreeNavigation.Dropdown label="Virtual Machine Requests" className="submenu">
				<Link to={`/subscriptions/${subscription?.id}/VirtualMachineRequest/new`}>
					<TreeNavigation.Item label="Create a Request" />
				</Link>
				<Link to={`/subscriptions/${subscription?.id}/virtualMachineRequestHistory`}>
					<TreeNavigation.Item label="Request History" />
				</Link>
			</TreeNavigation.Dropdown>)}
		</TreeNavigation>
	);
};

export default SubscriptionsHomeActiosnRow;
